import { ColumnActionsForPerson } from "./components/ColumnActionsForPerson";
import { ITableConfig } from "./interfaces/component/ITableConfig";

export const defaultPersonTableConfigID = "justsomerandomidforspecifyingatableconfig";
export const defaultPersonTableConfig: ITableConfig = {
  id: defaultPersonTableConfigID,
  height: 600,
  headerHeight: 70,
  rowHeight: 30,
  name: "Person Table",
  columns: [
    {
      title: "Index",
      columnType: "index",
      fieldName: "index",
      sortOrder: 0,
      sortable: false,
      width: 150,
      visible: true,
    },
    {
      title: "Name",
      fieldName: "name",
      columnType: "data",
      sortOrder: 1,
      sortable: true,
      filterType: "input",
      width: 150,
      visible: true,
    },
    {
      title: "Email",
      fieldName: "email",
      columnType: "data",
      sortOrder: 2,
      sortable: true,
      filterType: "input",
      width: 250,
      visible: true,
    },
    {
      title: "Age",
      fieldName: "age",
      columnType: "data",
      sortOrder: 3,
      sortable: true,
      filterType: "input",
      width: 150,
      visible: true,
    },
    {
      title: "Gender",
      fieldName: "gender",
      columnType: "data",
      sortOrder: 4,
      sortable: true,
      filterType: "select",
      width: 150,
      visible: true,
      filterOptions: [
        { label: "Male", value: "Male" },
        { label: "Female", value: "Female" },
      ],
    },
    {
      title: "Address",
      fieldName: "address",
      columnType: "data",
      sortOrder: 5,
      sortable: true,
      filterType: "input",
      width: 150,
      visible: true,
    },
    {
      title: "City",
      fieldName: "city",
      columnType: "data",
      sortOrder: 6,
      sortable: true,
      filterType: "input",
      width: 150,
      visible: true,
    },
    {
      title: "Postcode",
      fieldName: "postcode",
      columnType: "data",
      sortOrder: 7,
      sortable: true,
      filterType: "input",
      width: 150,
      visible: true,
    },
    {
      title: "Country",
      fieldName: "country",
      columnType: "data",
      sortOrder: 8,
      sortable: true,
      filterType: "input",
      width: 150,
      visible: true,
    },
    {
      title: "Action",
      fieldName: "",
      columnType: "action",
      sortOrder: 8,
      sortable: false,
      filterType: "input",
      width: 150,
      visible: true,
      render: (props) => <ColumnActionsForPerson {...props} />,
    },
  ],
};
